<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    class="new-function"
    >
    <div slot="title">
      <el-tabs v-model="activeTab" @tab-click="changeTab" class="head-tab">
        <!-- <el-tab-pane label="Message" name="1" />
        <el-tab-pane label="Notification" name="2" />
        <el-tab-pane label="Take Down" name="3" /> -->
        <el-tab-pane name="1">
        <span slot="label">{{ $t('Components.NewFunction.Notification') }}<i v-if="is_new_data['1']"></i></span>
        </el-tab-pane>
        <el-tab-pane name="2">
          <span slot="label">{{ $t('Components.NewFunction.Events') }}<i v-if="is_new_data['2']"></i></span>
        </el-tab-pane>
        <el-tab-pane name="3">
          <span slot="label">{{ $t('Components.NewFunction.SoldOutList') }}<i v-if="is_new_data['3']" style="right:-8px"></i></span>
        </el-tab-pane>
        <el-tab-pane name="4">
          <span slot="label">{{ $t('Components.NewFunction.ExportList') }}<i v-if="is_new_data['4']" style="right:-8px"></i></span>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div v-if="activeTab == 3" class="product">
      <div v-for="item in productList" :key="item.id" class="product-item f-b-c">
        <oss-img :width="40" :height="53" :src="item.imgUrl" />
        <div class="right">
          <div class="f-b">
            <div class="title ellipsis3">{{ item.productName }}</div>
            <div class="time">{{ item.en_date }}</div>
          </div>
          <div class="ellipsis">{{ item.spuCode ? `SPU：${item.spuCode}` : `SKU：${item.skuCode}` }}</div>
        </div>
      </div>
    </div>
    <div v-if="activeTab == 4" class="product">
      <div v-for="item in fileTaskList" :key="item.id" class="product-item f-b-c">
        <div class="right" style="height: 60px;">
          <div class="f-b-c">
            <div class="title ellipsis3">{{ item.taskTypeName }}</div>
            <div v-if="item.fileStatusName">
              <a :style="{color: fileStatusColor(item.fileStatus)}" :href="item.fileResultPath">{{ item.fileStatusName }}</a>
            </div>
            <div v-else :style="{ color: fileStatusColor(item.fileStatus) }">{{ item.fileStatusName }}</div>
          </div>
          <div class="ellipsis">{{ item.en_date }}</div>
        </div>
      </div>
    </div>
    <div v-else class="f">
      <div class="myTimeline">
        <el-timeline>
          <el-timeline-item
            v-for="(activity, index) in activities"
            :key="index"
            :timestamp="activity.en_date"
            :color="activity.id === activeId ? '#99C41C' : ''"
            size="normal"
          >
            <div @click="timeLineClick(activity)" class="pointer">
              <el-badge :value="activity.receiveState ? '': 'new'" class="item">
                <div style="font-weight: bold;font-size: 16px">{{ activity.title }}</div>
              </el-badge>
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>
      <div class="contentBox">
        <template v-if="currentContent.content">
          <div class="title f--c">
            <div class="round"></div>
            <div>{{ currentContent.title}}</div>
          </div>
          <div class="date">
            {{ $t('Components.NewFunction.UpdateTime') }}: {{ currentContent.createDate | dateForContent}}
          </div>
          <div class="content" v-html="currentContent.content" id="myContent"></div>
        </template>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import API from '@/api'
import dayjs from 'dayjs'
export default {
  data() {
    return {
      dialogVisible: false,
      activeTab: '1',
      activities: [],
      productList: [],
      fileTaskList: [],
      activeId: 233333,
      is_new_data: {}
    }
  },
  filters: {
    dateForContent(value) {
      if (!value) return ''
      return dayjs(value).format('YYYY-MM-DD')
    },
    dateForTimeLine(value) {
      if (!value) return ''
      return dayjs(value).format('MM-DD HH:mm')
    }
  },
  watch: {
    currentContent(val) {
      this.$nextTick(() => {
        const ele = document.querySelector('#myContent')
        if (ele) {
          this.replaceImageTag(ele, ele.clientWidth)
        }
      })
    }
  },
  computed: {
    currentContent() {
      let target = this.activities.find(e => e.id === this.activeId) || { content: '', title: '', sendTime: undefined }
      return target
    }
  },
  created() {
    this.stationLetterNewState()
    // this.newFunctionGetList()
  },
  methods: {
    show(activeTab) {
      this.activeTab = activeTab.toString()
      this.changeTab()
      this.dialogVisible = true
    },
    newFunctionGetList() {
      API.newFunctionGetList({ type: +this.activeTab }).then(res => {
        this.activities = res.data.map(item => ({
          ...item,
          en_date: new Intl.DateTimeFormat('en', { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }).format(item.createDate)
        }))
        if (!this.activities.find(e => e.id === this.activeId) && this.activities.length) this.timeLineClick(this.activities[0])
      })
    },
    handleClose() {
      this.dialogVisible = false
    },
    timeLineClick(activity) {
      this.activeId = activity.id
      if (!activity.receiveState) {
        const form = new FormData()
        form.append('id', activity.id)
        form.append('receiveState', 1)
        API.newFunctionUpdateStatus(form).then(() => {
          this.stationLetterNewState()
        })
        activity.receiveState = 1
      }
    },
    replaceImageTag(ele, clientWidth) {
      [...ele.children].forEach(e => {
        if (e.tagName === 'IMG') {
          const imgWidth = parseInt(e.getAttribute('width'))
          const imgHeight = parseInt(e.getAttribute('height'))
          if (imgHeight > imgWidth && imgWidth > clientWidth) {
            e.style.width = '100%'
          } else if (imgHeight > imgWidth && imgWidth < clientWidth) {
            e.style.height = `${imgHeight}px`
            e.style.display = 'block'
            e.style.margin = '0 auto'
            e.style.width = `${imgWidth}px`
          } else if (imgHeight < imgWidth && imgWidth > clientWidth) {
            e.style.width = '100%'
          } else if (imgHeight < imgWidth && imgWidth < clientWidth) {
            e.style.display = 'block'
            e.style.margin = '0 auto'
          } else if (imgHeight === imgWidth && imgWidth > clientWidth) {
            e.style.width = '100%'
          } else {
            e.style.display = 'block'
            e.style.margin = '0 auto'
          }
        }
        if (e.children) this.replaceImageTag(e, clientWidth)
      })
    },
    changeTab() {
      if (+this.activeTab === 3) this.productTakeDownSendsList()
      else if (+this.activeTab === 4) this.getFileTaskList()
      else this.newFunctionGetList()
    },
    // 前台-用户获取产品下架接收列表
    productTakeDownSendsList() {
      API.productTakeDownSendsList().then(({ data }) => {
        this.productList = data.map(item => ({
          ...item,
          en_date: new Intl.DateTimeFormat('en', { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }).format(item.createDate)
        })) || []
        if (data.length && !!this.is_new_data['3']) this.productTakeDownSends()
      })
    },
    // 前台-用户获取心愿单导出列表
    getFileTaskList() {
      API.getFileTaskList().then(({ data }) => {
        this.fileTaskList = data.list.map(item => ({
          ...item,
          en_date: new Intl.DateTimeFormat('en', { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }).format(item.createDate)
        })) || []
      })
    },
    // 获取是否有最新消息
    stationLetterNewState() {
      API.stationLetterNewState().then(res => {
        this.is_new_data = res.data
        this.$store.commit('common/set', { newFunctionIsRead: (!!res.data['1'] || !!res.data['2'] || !!res.data['3']) || false })
      })
    },
    // 前台-更新产品下架通知收件状态
    productTakeDownSends() {
      API.productTakeDownSends({ ids: this.productList.map(item => item.id), receiveState: 1 }).then(() => {
        this.stationLetterNewState()
      })
    },
    fileStatusColor(fileStatus) {
      if (fileStatus === 1 || fileStatus === 2) {
        return 'black'
      } else if (fileStatus === 4) {
        return 'red'
      } else {
        return '#99C41C' // Default color
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.new-function /deep/ .el-dialog__body{
  padding-top: 0;
}

.product{
  .product-item{
    padding: 14px 0;
    border-bottom: 1px solid #CDD4DD;
    img{
      width: 80px;
      height: 106px;
      border-radius: 6px;
      flex-shrink: 0;
      margin-right: 22px;
    }
    .right{
      flex: 1;
      height: 100px;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      color: #747A87;
      font-size: 14px;

      .title{
        font-size: 16px;
        line-height: 22px;
        color: #000;
        flex: 1;
        padding-right: 10%;
      }
      .time{
        flex-shrink: 0;
      }
    }
  }
}

.myTimeline {
  width: 260px;
  background-color: rgba(205, 212, 221, 0.17);
  padding: 20px 14px;
}
.contentBox {
  flex: 1;
  margin-left: 30px;
  max-height: 800px;
  overflow-y: auto;
  >.title {
    font-weight: bold;
    font-size: 18px;
    margin-bottom: 14px;
    .round{
      width: 6px;
      height: 6px;
      margin-right: 7px;
      border-radius: 100%;
      background-color: #99C41C;
    }
  }
  >.date {
    font-size: 12px;
    color: gray;
    margin-bottom: 14px;
  }
  >.content {
    padding-right: 20px;
    /deep/img {
      // width: 100% !important;
    }
  }

}
/deep/.el-dialog {
  min-width: 1300px;
  color: red;
}

.head-tab .el-tabs__item{
  position: relative;
  font-size: 16px;
  span i{
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #F56C6C;
    display: inline-block;
    position: absolute;
    top: 7px;
    right: 12px;
  }
}
</style>
